const slugMiddleware = (store) => (next) => (action) => {
  const slug = store.getState().slug;
  if (action.payload) {
    action = { ...action, payload: { ...action.payload, slug } };
  }
  next(action);
};

export default slugMiddleware;
